import styled from 'styled-components';
import { DefaultSkeletonWrapper } from '~/components/common/v2/skeleton-loader';

export const StyledSkeletonLarge = styled(DefaultSkeletonWrapper)`
  width: 85%;
`;

export const StyledSkeletonShort = (spacing: number) => styled(DefaultSkeletonWrapper)`
  margin-top: ${({ theme }) => theme.spacing(spacing)}px;
  width: 80%;
`;

export const StyledDivider = (spacing: number) => styled.div`
  margin-top: ${({ theme }) => theme.spacing(spacing)}px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.on[100]};
`;

export const SkeletonCardWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.surface[0]};
`;

export const SkeletonCardBody = styled.div`
  padding: ${({ theme }) => theme.spacing(4)}px;
`;
